import SignUp from "../components/Authentication/SignUp";

const SignUpPage = (): JSX.Element => {
  return <SignUp />;
};

export default SignUpPage;
